<template>
  <div class="home" id="container">
    <TopPanel @onLanguageSelected="setLanguage" @scrollTo="scrollTo" />
    <RoutaCarousel id="carousel" @scrollTo="scrollTo"></RoutaCarousel>
    <What id="what"/>
    <Why id="why"/>
    <Content id="content"/>
    <!--
    <References id="references"/>
    -->
    <!--
    <Contact id="contacts"/>
    -->
    <MinContact id="contacts"/>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import TopPanel from "@/components/TopPanel";
import RoutaCarousel from "@/components/RoutaCarousel";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import What from "@/components/What";
import References from "@/components/References";
import Why from "@/components/Why";
import Content from "@/components/Content";
import MinContact from "@/components/MinContact";
export default {
  name: 'home',
  components: {
    MinContact,
    Content,
    Why,
    References,
    What,
    Footer,
    Contact,
    RoutaCarousel,
    TopPanel
  },
  data () {
    return {
      locale: this.getLanguage()
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  },
  methods: {
    setLanguage: function (lang) {
      this.locale = lang
    },
    getLanguage: function () {
      let lang = navigator.language.split('-')[0]
      switch (lang) {
        case 'en':
          return 'en'
        case 'fi':
          return 'fi'
        case 'fr':
          return 'fr'
      }
      return 'en'
    },
    scrollTo: function (element) {
      let el = '#' + element
      var options = {
        easing: 'ease-in',
        offset: -60,
        force: true,
        cancelable: false,
        onStart: function(element) {
          // scrolling started
        },
        onDone: function(element) {
          // scrolling is done
        },
        onCancel: function() {
          // scrolling has been interrupted
        },
        x: false,
        y: true
      }
      this.$scrollTo(el, 500, options)
    }
  }
}
</script>
